export const formatErrorMessage = (error) => {
    const { message, details } = error?.response?.data?.errors || {};
    const value = details ? Object.values(details)[0] : '';
    const errorMessage = message ? `${message}\n${value}` : '';
    return errorMessage;
};